import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Login = () => import('../views/login/Login.vue')//登陆
const Index = () => import('../views/index/index.vue')//首页
const Home = ()=>import('../views/home/home.vue')
const Main = () => import('../views/main/Main.vue')//内容部分
const FormList = () => import('../views/formList/FormList')//基本表单
const Form = () => import('../views/form/Form')
const list = ()=>import('../views/list/list')
const OrganizationalGl = ()=>import('../views/OrganizationalGl/OrganizationalGl')//经销商管理
const Customeruser = ()=>import('../views/customeruser/customeruser')//客户管理
const UserRights = ()=>import('../views/userRights/userRights')//用户权限管理
const Password = ()=>import('../views/Password/Password')//修改密码
const Region = ()=>import('../views/region/region')//区域管理
const AlarmInformation = ()=>import('../views/alarmInformation/alarmInformation')//短信记录
const daily =()=>import('../views/daily/daily')//系统日报
const Passageway = ()=>import('../views/passageway/passageway')
const DataCurve = ()=>import('../views/dataCurve/dataCurve')
const Parameters = ()=>import('../views/parameters/parameters')
const DystemInfoChile = ()=>import('../views/systemInfoChile/systemInfoChile')//系统日志
const systemConfiguration = ()=>import('../views/systemConfiguration/systemConfiguration')//系统配置
const FootersConfing = ()=>import('../views/footersConfing/footersConfing')//页脚配置
const AppAdministration = ()=>import('../views/appAdministration/appAdministration')
const dome = ()=>import('../views/dome/dome')//测试页面
const CameraSettingsCont = ()=>import('../views/CameraSettings/CameraSettings')//摄像头设置
const allPhotos = ()=>import('../views/allPhotos/allPhotos')//抓拍
const ReplayTheater = ()=>import('../views/ReplayTheater/ReplayTheater')//录像回放
const ControlSet = ()=>import('../views/ControlSet/Controlset') 
const Publics = ()=>import('../views/publics/publics')   //公厕登录    实时数据
const Homepage = ()=>import('../views/publics/homepage')   //公厕登录  首页
const Gateway = ()=>import('../views/publics/gateway')   //公厕登录  网关
const routes = [{
      path: '/',
      redirect: '/login'
    },
    {
      path: "/login",
      name: 'login',
      component: Login,
    },
    {
      path: "/publics",
      name: 'publics',
      component: Publics,
    },
    {
      path: "/homepage",
      name: 'homepage',
      component: Homepage,
    },
    {
      path: "/gateway",
      name: 'gateway',
      component: Gateway,
    },
    {
      path: "/index",
      name: 'index',
      component: Index,
      redirect: '/formList',
      children: [{
        path: '/formList',
        name: 'formList',
        component: FormList
      },
      // {
      //   path: "/publics",
      //   name: 'publics',
      //   component: Publics,
      // },
      {
        path: '/main',
        name: 'main',
        component: Main

      },
      {
        path: '/form',
        name: 'form',
        component: Form
      },
      {
        path:'/organizationalGl',
        name:'organizationalGl',
        component:OrganizationalGl
      },
      {
        path:'/customeruser',
        name:'customeruser',
        component:Customeruser
      },
      {
        path:'/userRights',
        name:'userRights',
        component:UserRights
      },
      {
        path:'/password',
        name:'Password',
        component:Password
      },
      {
        path:'/region',
        name:'region',
        component:Region
      },
      {
        path:'/alarmInformation',
        name:'alarmInformation',
        component:AlarmInformation
      },
      {
        path:'/daily',
        name:'daily',
        component:daily
      },
      {
        path:'/passageway',
        name:'passageway',
        component:Passageway
      },
      {
        path:'/home',
        name:'home',
        component:Home
      },
      {
        path:'/parameters',
        name:'parameters',
        component:Parameters
      },
      {
        path: "/list",
        name: 'list',
        component: list,
      },
      {
        path:'/dataCurve',
        name:'dataCurve',
        component:DataCurve
      },
      {
        path:'/systemInfoChile',
        name:'systemInfoChile',
        component:DystemInfoChile
      },
      {
        path:'/systemConfiguration',
        name:"systemConfiguration",
        component:systemConfiguration
      },
      {
        path:'/footersConfing',
        name:'footersConfing',
        component:FootersConfing
      },
      {
        path:'/appAdministration',
        name:'appAdministration',
        component:AppAdministration
      },
      {
        path:'/CameraSettings',
        name:'CameraSettings',
        component:CameraSettingsCont
      },
      {
        path:'/allPhotos',
        name:'allPhotos',
        component:allPhotos
      },
      {
        path:'/ReplayTheater',
        name:'replayTheater',
        component:ReplayTheater
      },
      {
        path:'/dome',
        name:'dome',
        component:dome
      },
      {
        path:'/Controlset',
        name:'Controlset',
        component:ControlSet
      }


      
      ]
    },


]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //to 将要访问的路径
  // from 从那个路径跳转过来
  // next 是一个函数  next()//放行   next('/login')//强制跳转
  window.alert = function () {
    return;
  };
  // if (to.path == '/publics') return next()
  if (to.path == '/publics') return next()
  if (to.path == '/homepage') return next()
  if (to.path == '/gateway') return next()
  if (to.path == '/login') return next()
  const token = sessionStorage.getItem("token")
  if (!token) return next('/login')
  next()

});

export default router